export default __webpack_public_path__ + "static/media/0.bdd16797.svg";